import Profile from '@/components/profile';

export default Profile;
